import { render, staticRenderFns } from "./AbcCurveTable.vue?vue&type=template&id=92c6ea96&"
import script from "./AbcCurveTable.vue?vue&type=script&lang=js&"
export * from "./AbcCurveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports